import BaseForm from '../base';
export class GasMeterPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: []
};
